module.exports = __webpack_public_path__ + "static/media/profile-frame-left.6c0112a1.svg";